module.exports = "../img/Liniers-Horizontal.jpg";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/Liniers-Horizontal.jpg
// module id = 34
// module chunks = 0